import { IApps } from "../master/apps";
import { IWidgets } from "../master/widgets";

export interface IStudentDashboard {
  getAllWidgets: Function;
  widgets: IWidgets[];
  getAllApps: Function;
  apps: IApps[];
}

export interface IAdminDashbordMasters {
  userType: ConfigUserTypes;
  // getWidgets:Function
  // widgets:IWidgets[]
  // getApps:Function
  // apps:IApps[]
  // getStudentHelps:Function
  // studentHelps:IWidgets[]
  // getStudentResources:Function
  // studentResources:IApps[]
  // getButtons:Function
  // buttons:IWidgets[]
  // getNotifications:Function
  // notifications:IApps[]
}

export interface IAdminMasterNav {
  setMasterItem: Function;
  masterItem: MasterItems;
  configUserRole: number;
}

export enum ConfigUserTypes {
  Config = 1,
  College = 2,
  Department = 3,
  Staff = 4,
  Faculty = 5,
  Student = 6,
  Feedback = 7,
}

export enum UserTypes {
  SuperAdmin = 1,
  CollegeAdmin = 2,
  DepartmentAdmin = 3,
  Staff = 4,
  Faculty = 5,
  Student = 6,
  Freshman = 7
}

export enum MasterItems {
  Button = 1,
  Widgets = 2,
  App = 3,
  StudentResource = 4,
  StudentHelp = 5,
  Notification = 6,
  Snapshots = 7,
  Training = 8,
  Report = 9,
  DepartmentResource = 10,
  TechnologyResource = 11,
  MediaContent = 12,
  TrainingHelp = 13,
}

export enum TaskRespects{
  Student = 1,
  Class = 2,
  Department = 3
}

export enum ReportFrequency{
  Daily = 1,
  Monthly = 2,
  Yearly = 3
}

export enum FreshmanItems {
  MainStep = 1,
  SubStep = 2,
  Configuration = 3
}
